
import React from 'react';
import { useFormContext } from 'react-hook-form';
import Grid from '@mui/material/Grid';
import MDBox from '../../../components/MDBox';
import MDTypography from '../../../components/MDTypography';
import { Box } from '@mui/material';

const ConfirmationStep = () => {
  const { getValues } = useFormContext();
  const values = getValues();

  // Helper to format date
  const formatDate = (date) => {
    if (!date) return 'N/A';
    // If it's a Dayjs object (from DatePicker)
    if (date && typeof date.format === 'function') {
        return date.format('YYYY-MM-DD');
    }
    // If it's a Date object
    if (date instanceof Date) {
        return date.toLocaleDateString();
    }
    return date;
  };

  const getGenderLabel = (val) => {
    if (val === 1) return 'Male';
    if (val === 2) return 'Female';
    if (val === 3) return 'Other';
    return 'Unknown';
  };
  
  const avatarUrl = values.avatar instanceof File ? URL.createObjectURL(values.avatar) : null;

  return (
    <MDBox>
      
      
      <MDBox mb={3} p={2} border="1px solid #ddd" borderRadius="lg">
        <MDTypography variant="h6" fontWeight="bold" textTransform="capitalize" mb={2}>
          Team Leader
        </MDTypography>
        <Grid container spacing={2}>
           {avatarUrl && (
             <Grid item size={6} display="flex" gap={3} mb={2}>
                <img src={avatarUrl} alt="Avatar" style={{ width: 100, height: 100, borderRadius: '50%', objectFit: 'cover' }} />
                <Box>
                 <MDTypography variant="button" fontWeight="bold" color="text">اسم المشرف:</MDTypography>

            <MDTypography variant="body2" >{values.user_name}</MDTypography>
                </Box>
             </Grid>
           )}
           <Grid item size={6}>
           
           </Grid>
           
           <Grid item size={6}>
            <MDTypography variant="button" fontWeight="bold" color="text">البريد الالكتروني:</MDTypography>
            <MDTypography variant="body2">{values.email}</MDTypography>
           </Grid>
           
           <Grid item size={6}>
            <MDTypography variant="button" fontWeight="bold" color="text">رقم الهاتف:</MDTypography>
            <MDTypography variant="body2">{values.phone || 'N/A'}</MDTypography>
           </Grid>
           
           <Grid item size={6}>
            <MDTypography variant="button" fontWeight="bold" color="text">الجنس:</MDTypography>
            <MDTypography variant="body2">{getGenderLabel(values.gender)}</MDTypography>
            </Grid>
           
           <Grid item size={6}>
            <MDTypography variant="button" fontWeight="bold" color="text">تاريخ الميلاد:</MDTypography>
            <MDTypography variant="body2">{formatDate(values.birth_date)}</MDTypography>
           </Grid>
        </Grid>
      </MDBox>

      <MDBox mb={3} p={2} border="1px solid #ddd" borderRadius="lg">
        <MDTypography variant="h6" fontWeight="bold" textTransform="capitalize" mb={2}>
          بيانات الفريق
        </MDTypography>
        <Grid container spacing={2}>
           <Grid item size={{xs:12,md:6}}>
            <MDTypography variant="button" fontWeight="bold" color="text">اسم الفريق:</MDTypography>
            <MDTypography variant="body2">{values.name}</MDTypography>
           </Grid>
           
           <Grid item size={{xs:12,md:6}}>
            <MDTypography variant="button" fontWeight="bold" color="text">المدينة:</MDTypography>
            <MDTypography variant="body2">{values.city || 'N/A'}</MDTypography>
           </Grid>
           
           <Grid item size={{xs:12,md:6}}>
            <MDTypography variant="button" fontWeight="bold" color="text">العنوان:</MDTypography>
            <MDTypography variant="body2">{values.address || 'N/A'}</MDTypography>
           </Grid>
           
           <Grid item size={{xs:12,md:6}}>
            <MDTypography variant="button" fontWeight="bold" color="text">الهدف الشهري:</MDTypography>
            <MDTypography variant="body2">{values.monthly_target}</MDTypography>
           </Grid>
           
           <Grid item size={{xs:12,md:6}}>
            <MDTypography variant="button" fontWeight="bold" color="text">العدد المطلوب:</MDTypography>
            <MDTypography variant="body2">{values.max_agents}</MDTypography>
           </Grid>
           
           <Grid item size={{xs:12,md:6}}>
            <MDTypography variant="button" fontWeight="bold" color="text">الخطة:</MDTypography>
            <MDTypography variant="body2" textTransform="uppercase">{values.subscription_plan}</MDTypography>
           </Grid>
           
           <Grid item size={{xs:12,md:6}}>
            <MDTypography variant="button" fontWeight="bold" color="text">الرسوم الشهري:</MDTypography>
            <MDTypography variant="body2">{values.monthly_fee}</MDTypography>
           </Grid>
           
            <Grid item size={{xs:12,md:6}}>
            <MDTypography variant="button" fontWeight="bold" color="text">تاريخ انتهاء الاشتراك:</MDTypography>
            <MDTypography variant="body2">{formatDate(values.subscription_ends_at)}</MDTypography>
           </Grid>

           <Grid item size={{xs:12,md:6}}>
            <MDTypography variant="button" fontWeight="bold" color="text">الحالة:</MDTypography>
            <MDTypography variant="body2" textTransform="uppercase">{values.status}</MDTypography>
           </Grid>
        </Grid>
      </MDBox>
    </MDBox>
  );
};

export default ConfirmationStep;
